export default {
  home: 'Casa',
};
